/**
 * Created by Mikhail Menshenin on 27.08.2024
 */

Reward.register("shields", {
    countable: true,
    controls: "shields",
    flyingAnimation: Reward.JUMP_COLLECT_ANIMATION,

    getIcon: function () {
        return bundles.reward_icons.frames.reward_shield_png;
    },

    receive: function (value) {
        const shields = cleverapps.shields.get() + value;
        cleverapps.shields.set(shields, true);

        return function () {
            cleverapps.shields.change();
        };
    }
});
